"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-marcello-piteglio": {
    "459710b8": [{
      "hkey": "e1be3619",
      "slug": "san-marcello-piteglio",
      "name": "San Marcello Piteglio",
      "primary": true,
      "skipSearch": false
    }],
    "la-macchia-antonini": [{
      "hkey": "e1be3619",
      "slug": "san-marcello-piteglio",
      "name": "San Marcello Piteglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a232d4d": [{
      "hkey": "ab11712a",
      "slug": "maresca-tafoni",
      "name": "Maresca-Tafoni",
      "primary": true,
      "skipSearch": false
    }],
    "maresca": [{
      "hkey": "ab11712a",
      "slug": "maresca-tafoni",
      "name": "Maresca-Tafoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;